import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

type Post = {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  content: any;
  published_at: string | null;
};

export default function PostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState<Post | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    supabase
      .from("posts")
      .select("id,title,slug,excerpt,content,published_at")
      .eq("slug", slug)
      .eq("status", "published")
      .single()
      .then(({ data }) => setPost(data ?? null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="p-6">Loading…</div>;
  if (!post) return <div className="p-6">Post not found.</div>;

  return (
    <article className="mx-auto max-w-3xl px-6 py-10 prose dark:prose-invert">
      <h1 className="text-3xl font-semibold tracking-tight">{post.title}</h1>
      {post.excerpt && (
        <p className="text-muted-foreground mt-2">{post.excerpt}</p>
      )}
      <div className="mt-6 space-y-4">
        {/* Render basic content; for now assume content is simple blocks or HTML string */}
        {typeof post.content === "string" ? (
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        ) : (
          <pre className="text-sm overflow-auto">{JSON.stringify(post.content, null, 2)}</pre>
        )}
      </div>
    </article>
  );
}
